import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';

const HEADERS = {
  headers: { Authorization: 'bearer ' + localStorage.getItem('token') },
};

function ModalE(props) {
  const { notesString } = useTranslationHook();

  const { equipBrandString, equipModelString, equipMDescString, equipMCTitle } =
    useTranslationHook();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [models, setModels] = useState([]);
  const [model, setModel] = useState(null);
  const [businessUnit, setBusinessUnit] = useState('');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (!props.show) return;
    customAxios
      .get(`${GlobalVariables.getURL()}models/`, HEADERS)
      .then((response) => {
        setModels(response.data.data || response.data || []);
      })
      .catch((error) => console.log(error));
  }, [props.show]);

  function hide() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Tipo de equipo creado exitosamente en la base de datos.',
    });
    props.getEquips();
  }

  function createEquip(event) {
    event.preventDefault();
    if (!model) return;
    customAxios
      .post(
        `${GlobalVariables.getURL()}createEquip`,
        {
          // url to POST
          name: name,
          model_id: model.id,
          description: description,
          business_unit: businessUnit,
          notes,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        },
      )
      .then(
        (response) => {
          localStorage.setItem('equipID', response.data.equipmentId);
          hide();
        },
        (error) => {
          console.log(error);
          getToast({
            status: 'error',
            title: 'Error al crear tipo de equipo. Vuelve a intentarlo.',
          });
        },
      );
  }

  const handleEntering = () => {
    setName('');
    setDescription('');
    setModel(null);
    setBusinessUnit('');
    setNotes('');
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Nuevo tipo de equipo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="equips-form" onSubmit={createEquip}>
          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label="Nombre del tipo de equipo"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <Autocomplete
                sx={{ width: '100%' }}
                options={models}
                value={model}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) =>
                  option.brand_name
                    ? `${option.name} (${option.brand_name})`
                    : option.name || ''
                }
                onChange={(event, newValue) => setModel(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Modelo" required />
                )}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                multiline
                rows={4}
                sx={{ width: '100%' }}
                label="Características"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label="Unidad de Negocio"
                type="text"
                value={businessUnit}
                onChange={(e) => setBusinessUnit(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label={notesString}
                type={'text'}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          form="equips-form"
          className="save-modal-button"
          disabled={!model}
        >
          Guardar
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalE;
